import script from "./LiftUpPageBlock.vue?vue&type=script&lang=js"
export * from "./LiftUpPageBlock.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__